import { render, staticRenderFns } from "./CardAsistencia.vue?vue&type=template&id=40278673&scoped=true&"
import script from "./CardAsistencia.vue?vue&type=script&lang=js&"
export * from "./CardAsistencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40278673",
  null
  
)

export default component.exports